<section class="body-section">
    <div class="container">
        <main>
            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box Rankinghistory">
                    <div class="header-container">
                        <h3 class="section-header">KYC Info
                        </h3>
                    </div>
        <div class="col-md-12">
            <p-table #dt [value]="kycDetails" 
            [scrollable]="true" scrollHeight="auto" scrollDirection="both"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th style="width: 0; min-width: 0px;" class="icons"></th> -->
                    <th class="rank">Created Date </th>
                    <th class="tournamentName">Pancard Number</th>
                    <th class="MatchType">Aadharcard Number</th>
                    <th class="AgeGroup">Bank Name</th>
                    <th class="Points">Account Number</th>
                    <th class="Points">IFSC</th>
                    <th class="Points">Status</th>
                    <th class="Points">Action</th>
                    <!-- <th class="button-table"></th> -->
                </tr>
            </ng-template>
                <!-- <ng-template pTemplate="header">
                    <tr>
                        <th class="name-td-partner rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                            rowspan="1" colspan="1" style="color: black;background: #f6f6f6!important;">
                            <div>Created Date
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>Pancard Number
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>Aadharcard Number
                            </div>
                        </th>
                        <th class="sorting_disabled current-request-location-td" rowspan="1" colspan="1">
                            <div>Bank Name
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>Account Number
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>IFSC
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>Status
                            </div>
                        </th>
                        <th class="sorting_disabled" rowspan="1" colspan="1">
                            <div>Action
                            </div>
                        </th>
                    </tr>
                </ng-template> -->
                <ng-template pTemplate="body" let-kycData>
                    <tr class="normal-tr"> 
                       
                        <td class="rank">
                            <span class="mobile-heading-lable">
                                Created Date:
                            </span>
                            {{kycData.created_at | date:'dd/MM/yyyy'}}
                        </td>
                        <td class="tournamentName">
                            <span class="mobile-heading-lable">
                                Pancard Number:
                            </span>
                            {{kycData.panCardNumber}}
                        </td>
                        <td class="MatchType">
                            <span class="mobile-heading-lable">
                                Aadharcard Number:
                            </span>
                            {{kycData.aadhaarCardNumber}}
                        </td>
                        <td class="AgeGroup">
                            <span class="mobile-heading-lable">
                                Bank Name:
                            </span>
                            {{kycData.bankData[0]?.bankName}}
                        </td>
                        <td class="Points">
                            <span class="mobile-heading-lable">
                                Account Number:
                            </span>
                            {{kycData.bankData[0]?.bankAccountNumber}}
                        </td>
                        <td class="Points">
                            <span class="mobile-heading-lable">
                                IFSC:
                            </span>
                            {{kycData.bankData[0]?.ifsc}}
                        </td>
                        <td class="Points">
                            <span class="mobile-heading-lable">
                                Status:
                            </span>
                            <div class="" *ngIf="kycData.bankData[0]?.isBankVerified" [rounded]="true">Approved</div>
                            <div class="" *ngIf="!kycData.bankData[0]?.isBankVerified" [rounded]="true">Pending</div>
                        </td>
                        <td class="button-table">
                            <span *ngIf="!kycData.isAadharVerified || !kycData.isDocumentComplete" class="kyc-btn">
                                <button routerLink="../kyc" class="edit-kyc-btn">Edit KYC</button>
                            </span>
                               
                        </td>
                    </tr>
                    <!-- <tr class="p-selectable-row">
                        <td>
                            {{kycData.created_at | date:'d-M-yyyy'}}
                        </td>
                        <td>
                            {{kycData.panCardNumber}}
                        </td>
                        <td>
                            {{kycData.aadhaarCardNumber}}
                        </td>
                        <td>
                            {{kycData.bankData[0].bankName}}
                        </td>
                        <td>
                            {{kycData.bankData[0].bankAccountNumber}}
                        </td>
                        <td>
                            {{kycData.bankData[0].ifsc}}
                        </td>
                        <td class="status-Td">
                            <p-tag class="bg-success text-white" *ngIf="kycData.bankData[0].isBankVerified"
                                [rounded]="true">Approved</p-tag>
                            <p-tag class="bg-warning text-dark" *ngIf="!kycData.bankData[0].isBankVerified"
                                [rounded]="true">Pending</p-tag>
                        </td>
                        <td *ngIf="!kycData.isAadharVerified || !kycData.isDocumentComplete">
                            <button routerLink="../kyc">Edit KYC</button>
                        </td>
                    </tr> -->
                </ng-template>
                <!-- <ng-template pTemplate="body" let-kycData> -->
                    <!-- <tr class="kyc-data">
                        <td class="name-td-partner rin-dt-ellpsis-overflow-1 rin-dt-align-left">
                            <div class="data">
                                <span class="mobileversion-lable">Created Date:</span>
                                {{kycData.created_at | date:'d-M-yyyy'}}
                            </div>
                            <br>
                        </td>
                        <td class="rating-td-partner">
                            <span class="rin-type-label state-finished">
                                <span class="mobileversion-lable">Pancard Number:</span>
                                {{kycData.panCardNumber}}
                            </span></td>
                        <td><span class="rin-type-label state-finished">
                                <span class="mobileversion-lable">Aadharcard Number:</span>
                                 {{kycData.aadhaarCardNumber}}
                            </span></td>
                        <td class="current-request-location-td">
                            <span class="rin-type-label state-finished">
                                <span class="mobileversion-lable">Bank Name:</span>
                                {{kycData.bankData[0].bankName}}
                            </span></td>
                        <td><span class="rin-type-label state-finished">
                                <span class="mobileversion-lable">Account Number:</span>
                                {{kycData.bankData[0].bankAccountNumber}}
                            </span></td>
                        <td><span class="rin-type-label state-finished">
                                <span class="mobileversion-lable">IFSC:</span> {{kycData.bankData[0].ifsc}}
                            </span></td>
                        <td class="mobile-status">
                            <div class="" *ngIf="kycData.bankData[0].isBankVerified" [rounded]="true">Approved</div>
                            <div class="" *ngIf="!kycData.bankData[0].isBankVerified" [rounded]="true">Pending</div>
                        </td>

                        <td class="buttons-action-div">
                            <span *ngIf="!kycData.isAadharVerified || !kycData.isDocumentComplete">
                                <button routerLink="../kyc">Edit KYC</button>
                            </span>
                        </td>
                    </tr> -->
                    <!-- <tr class="p-selectable-row">
                                    <td>
                                        {{kycData.created_at | date:'d-M-yyyy'}}
                                    </td>
                                    <td>
                                        {{kycData.panCardNumber}}
                                    </td>
                                    <td>
                                        {{kycData.aadhaarCardNumber}}
                                    </td>
                                    <td>
                                        {{kycData.bankData[0].bankName}}
                                    </td>
                                    <td>
                                        {{kycData.bankData[0].bankAccountNumber}}
                                    </td>
                                    <td>
                                        {{kycData.bankData[0].ifsc}}
                                    </td>
                                    <td class="status-Td">
                                        <p-tag class="bg-success text-white" *ngIf="kycData.bankData[0].isBankVerified"
                                            [rounded]="true">Approved</p-tag>
                                        <p-tag class="bg-warning text-dark" *ngIf="!kycData.bankData[0].isBankVerified"
                                            [rounded]="true">Pending</p-tag>
                                    </td>
                                    <td *ngIf="!kycData.isAadharVerified || !kycData.isDocumentComplete">
                                        <button routerLink="../kyc">Edit KYC</button>
                                    </td>
                                </tr> -->
                <!-- </ng-template> -->
                <!-- <ng-template pTemplate="summary">
                    <div *ngIf="presentKycData && !presentButrejected"
                        class="flex align-items-center justify-content-between">
                        Email admin at <span><a href="mailto:support@tplsport.com"
                                style="cursor: pointer;text-decoration: underline; text-transform: lowercase; margin-left: 2px;">
                                support@tplsport.com.</a></span> for adding another new KYC
                        details
                    </div>
                </ng-template> -->
                <!-- <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div class="not-found-section">
                                <div class="col-md-12 not-found-body">
                                    <img src="assets/img/logo/not-found.gif" alt="">
                                    <h4>Sorry! No Request Found </h4>


                                </div>

                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{totalOpponentRecords }} Kyc
                    </div>
                </ng-template> -->
            </p-table>
        </div>
    </div>
</div>
</main>
</div>
</section>